/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React from 'react';
import PropTypes from 'prop-types';
import info16 from '@ba-ui-toolkit/ba-graphics/dist/icons-js/information_16';
import SVGIcon from '@ba-ui-toolkit/svgicon';
import Link from '@ba-ui-toolkit/link';
import { alertModel } from '../AlertPropTypes';
import styles from './AlertMessage.scss';
import stringResource from '../nls/StringResource';

const alertMessageClassName = styles.alertMessageClassName.replace(/"/g, '');
const messageContainerClassName = styles.messageContainerClassName.replace(/"/g, '');
const dismissContainerClassName = styles.dismissContainerClassName.replace(/"/g, '');
const optionalTitleClassName = styles.optionalTitleClassName.replace(/"/g, '');

function renderOptionalTitle(title) {
	return (
		<React.Fragment>
			<SVGIcon iconId={info16.id} />
			<span className={optionalTitleClassName}>{title}</span>
		</React.Fragment>
	);
}
export default function AlertMessage(props) {
	const { alert, onDismiss } = props;
	if (!alert) {
		return false;
	}

	return (
		<div className={alertMessageClassName}>
			<div className={messageContainerClassName}>
				{alert.title && renderOptionalTitle(alert.title)}
				{alert.message}
			</div>
			<div className={dismissContainerClassName}>
				<Link onClick={onDismiss}>{stringResource.get('dismiss')}</Link>
			</div>
		</div>
	);
}

AlertMessage.propTypes = {
	alert: alertModel,
	onDismiss: PropTypes.func,
};
